// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2XN9-","bigColWidth":"Table_bigColWidth__iVx8W","biggerColWidth":"Table_biggerColWidth__24_2k","row":"Table_row__PYtX5","col":"Table_col__vd4XD"};